// extracted by mini-css-extract-plugin
export default {"tasks":"style_tasks__N5bMG"};